import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";

const CountryRepVerificationPage = () => {
  const [searchParams] = useSearchParams();
  const email = searchParams.get("email");
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchProfile = async () => {
      if (!email) {
        setError("No email provided in the URL.");
        setLoading(false);
        return;
      }

      try {
        const response = await axios.get(`https://dash.bestdiplomats.org/api/method/country-rep-verification`, {
          params: { email },
        });
        const data = response?.data?.data;

        if (data && data.user?.email) {
          setProfile(data);
        } else {
          throw new Error("Profile could not be verified.");
        }
      } catch (err) {
        setError(err.response?.data?.message || err.message || "Profile could not be verified.");
      } finally {
        setLoading(false);
      }
    };

    fetchProfile();
  }, [email]);

  const renderStatusUI = (status) => {
    switch (status) {
      case "Approved":
        return (
          <div className="bg-green-50 p-4 rounded-lg shadow-md border border-green-300">
            <div className="flex justify-center mb-4">
              <img
                src={
                  profile?.user?.user_image
                    ? "https://dash.bestdiplomats.org" + profile?.user?.user_image
                    : "/placeholder-profile.png"
                }
                alt={profile.user?.full_name}
                className="h-28 w-28 rounded-full object-cover border-4 border-green-500"
              />
            </div>
            <h2 className="text-2xl font-bold text-green-800 mb-1">{profile?.user?.full_name}</h2>
            <p className="text-gray-600">{profile?.delegate_profile?.nationality}</p>
            <p className="text-gray-500 text-sm mb-3">
              Joined on {new Date(profile?.country_rep_profile?.creation).toLocaleDateString()}
            </p>
            <div className="bg-green-500 text-white px-4 py-2 rounded-full inline-block font-medium text-sm">
              ✅ Approved Country Representative
            </div>
          </div>
        );

      case "Probation":
        return (
          <div className="bg-yellow-50 p-4 rounded-lg shadow-md border border-yellow-300">
            <div className="flex justify-center mb-4">
              <img
                src={
                  profile?.user?.user_image
                    ? "https://dash.bestdiplomats.org" + profile?.user?.user_image
                    : "/placeholder-profile.png"
                }
                alt={profile.user?.full_name}
                className="h-28 w-28 rounded-full object-cover border-4 border-yellow-500"
              />
            </div>
            <h2 className="text-2xl font-bold text-yellow-800 mb-1">{profile?.user?.full_name}</h2>
            <p className="text-gray-600">{profile?.delegate_profile?.nationality}</p>
            <p className="text-gray-500 text-sm mb-3">
              Joined on {new Date(profile?.country_rep_profile?.creation).toLocaleDateString()}
            </p>
            <div className="bg-yellow-500 text-white px-4 py-2 rounded-full inline-block font-medium text-sm">
              🕒 Currently on Probation
            </div>
          </div>
        );

      default:
        return (
            <div className="bg-gray-50 p-5 rounded-lg shadow-md border border-gray-300">
            <div className="flex justify-center mb-4">
                <img
                src={
                    profile?.user?.user_image
                    ? "https://dash.bestdiplomats.org" + profile?.user?.user_image
                    : "/placeholder-profile.png"
                }
                alt={profile?.user?.full_name || "Representative"}
                className="h-24 w-24 rounded-full object-cover border-4 border-gray-400"
                />
            </div>
            <h2 className="text-xl font-semibold text-gray-700 mb-1">
                {profile?.user?.full_name || "Representative"}
            </h2>
            <p className="text-gray-600">{profile?.delegate_profile?.nationality || "Nationality not available"}</p>
            <div className="bg-yellow-100 text-yellow-800 px-4 py-2 rounded-full inline-block font-medium text-sm mb-2">
                ⚠️ Profile Pending Review
            </div>
            <p className="text-gray-500 text-sm">
                This representative’s profile is incomplete or not yet reviewed and <strong>cannot be verified at this time.</strong>
            </p>
            </div>
        );

    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
      <div className="max-w-md w-full bg-white shadow-xl rounded-2xl p-6 text-center">
        {loading ? (
          <div className="animate-pulse">
            <div className="h-24 w-24 rounded-full bg-gray-300 mx-auto mb-4" />
            <div className="h-4 bg-gray-300 rounded mb-2" />
            <div className="h-4 bg-gray-300 rounded mb-2" />
            <div className="h-4 bg-gray-300 rounded w-1/2 mx-auto" />
          </div>
        ) : error ? (
          <div>
            <div className="text-red-500 text-2xl font-semibold mb-2">Verification Failed</div>
            <p className="text-gray-600 mb-4">{error}</p>
          </div>
        ) : (
          renderStatusUI(profile?.country_rep_profile?.profile_status)
        )}
      </div>
    </div>
  );
};

export default CountryRepVerificationPage;
